




















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
import Enums from '@/lib/enums'
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import appconst from '@/lib/appconst';
import moment from 'moment'
Vue.use(Preview);

class PageBackDeliveryreceiptRequest extends PageRequest {
    storeId?: number;
    beginTime?: Date;
    endTime?: Date;
    batchNumber: string;
    logisticsNumber: string;
    logisticMethod: string;
}

@Component({
    name: "pagebackDeliveryreceipt",
})
export default class PageBackDeliveryreceipt extends AbpBase {
    storeaddressList: Array<storeaddressInfo> = [];
    pagerequest: PageBackDeliveryreceiptRequest = new PageBackDeliveryreceiptRequest();
    creationTime: Date[];
    get list() {
        return this.$store.state.deliveryreceipt.list;
    };
    get loading() {
        return this.$store.state.deliveryreceipt.loading;
    }

    pageChange(page: number) {
        this.$store.commit('deliveryreceipt/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('deliveryreceipt/setPageSize', pagesize);
        this.getpage();
    }
    async searchPage() {
        this.$store.state.deliveryreceipt.currentPage = 1;
        this.getpage();
    }

    async getpage() {
        if (this.pagerequest.storeId > 0) {

        }
        else {
            this.$Message.error("请选择仓库！");
            return;
        }
        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        } else {
            this.pagerequest.beginTime = null;
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        } else {
            this.pagerequest.endTime = null;
        }
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

        await this.$store.dispatch({
            type: 'deliveryreceipt/getAll',
            data: this.pagerequest
        })

    }


    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        if (this.storeaddressList.length == 1) {
            this.pagerequest.storeId = this.storeaddressList[0].id;
        }
        else {
            this.storeaddressList.push(a);
            this.pagerequest.storeId = null;
        }
    }
  
    get pageSize() {
        return this.$store.state.deliveryreceipt.pageSize;
    }
    get totalCount() {
        return this.$store.state.deliveryreceipt.totalCount;
    }
    get currentPage() {
        return this.$store.state.deliveryreceipt.currentPage;
    }
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center',

        },{
            title: '仓库名称',
            key: 'storeName',
            width: 120,
        },
        {
            title: '批次号',
            key: 'batchNumber',
            width: 150,

        },
        {
            title: '物流编号',
            key: 'logistic',
            width: 150,
        },
        {
            title: '物流方式',
            key: 'logisticMethod',
            width: 150,
        },
        {
            title: '创建时间',
            width: 230,
            render: (h: any, params: any) => {
                return h('div', (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime))))
            }
        },
        {
            title: '创建人',
            key: 'creatorUserName',
            width: 90,
        }
    ]
    async created() {
        this.getData();
        this.getpage();
    }
}
